export const environment = {
  production: false,
  userAdminPanelApiUrl: "https://verify-users-dev.salicru.com/api"
};
